import React from 'react';
import { NavLink, Outlet } from "react-router-dom";
import styles from "../styles/SectionLayout.module.css";

const SectionLayout = ({ title, tabs = [] }) => {
  return (
    <div className={styles.section}>
      <h1>{title}</h1>

      <nav className={styles.tabs}>
        {tabs.map(({ to, label, end }, i) => (
          <NavLink
            key={i}
            to={to}
            end={end}
            className={({ isActive }) => (isActive ? `${styles.tab} ${styles.active}` : styles.tab)}
          >
            {label}
          </NavLink>
        ))}
      </nav>

      <hr />
      <Outlet />
    </div>
  )
}

export default SectionLayout